import FollowersListModal from './FollowersListModal';

export default FollowersListModal;
